<section class="contentful-landing-page-section" [ngClass]="classToAdd">
  <div [ngClass]="{ 'background-wrapper': backgroundImageAsset && contentfulCategory?.backgroundImageAssetUrl }">
    @if (contentfulCategory?.backgroundImageAssetUrl || contentfulCategory?.backgroundImageMobileAssetUrl) {
      <app-contentful-cloudinary-picture
        class="text-center image-wrapper d-md-block"
        [cloudinaryBackgroundImageAsset]="backgroundImageAsset"
        [cloudinaryBackgroundImageMobileAsset]="mobileBackgroundImageAsset"
      />
    }

    @if (contentfulCategory?.heroImageUrl) {
      <app-contentful-cloudinary-image class="text-center image-wrapper" [cloudinaryImage]="heroImage" [mediaType]="'image'" />
    }

    @if (contentfulCategory?.videoUrl) {
      <app-contentful-cloudinary-video [cloudinaryVideoUrl]="contentfulCategory?.videoUrl" [mediaType]="'video'" />
    }

    <app-contentful-landing-page-section-body
      [contentfulCategory]="contentfulCategory"
      [articleBreadcrumbs]="articleBreadcrumbs"
      [whiteText]="whiteText"
      [aligned]="aligned"
      [index]="index"
    />
  </div>
</section>
